import { render, staticRenderFns } from "./CustomReportFilterChip.vue?vue&type=template&id=3d98a19c"
import script from "./CustomReportFilterChip.vue?vue&type=script&lang=js"
export * from "./CustomReportFilterChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports